<header class="header">
  <div class="header__col-left">
    <div class="header__facility">
      <span class="header__facility-label">FACILITY</span>
      <button
        type="button"
        class="header__facility-trigger"
        [class.header__facility-trigger--disabled]="!canSelectFacility()"
        [attr.aria-expanded]="facilityMenuOpen()"
        [attr.aria-label]="'Select facility. Current facility: ' + facilityName()"
        [disabled]="!canSelectFacility()"
        aria-haspopup="menu"
        (click)="onFacilityMenuToggle()">
        <span class="header__facility-name">{{ facilityName() }}</span>
        <img
          src="/assets/icons/caret-vector.svg"
          alt=""
          aria-hidden="true"
          class="header__facility-arrow"
          [class.header__facility-arrow--open]="facilityMenuOpen()" />
      </button>

      @if (facilityMenuOpen() && canSelectFacility()) {
        <div class="header__facility-menu" role="menu" aria-label="Facility filter">
          @for (facility of facilities(); track facility.id) {
            <button
              type="button"
              class="header__facility-option"
              [class.header__facility-option--active]="facility.id === selectedFacilityId()"
              [attr.aria-checked]="facility.id === selectedFacilityId()"
              role="menuitemradio"
              (click)="onFacilitySelected(facility.id)">
              {{ facility.name }}
            </button>
          }
        </div>
      }
    </div>
  </div>

  <div class="header__col-center">
    <a
      class="header__branding"
      href="/">
      <img
        src="/assets/icons/chevron-logo.png"
        alt="Chevron Logo"
        class="header__logo" />
      <span class="header__title">
        <span class="header__title-main">Integrated Operations Platform</span>
        @if (showEnvBadge) {
          <span class="header__title-sep" aria-hidden="true">&middot;</span>
          <span
            class="header__env-badge"
            [class]="'header__env-badge--' + envName"
            [title]="'Environment: ' + envName">
            {{ envName }}
          </span>
        }
      </span>
    </a>
  </div>

  <div class="header__col-right">
    @if (fullName()) {
      <div class="header__user">
        <img
          [src]="avatarUrl()"
          alt="User Avatar"
          class="header__user-avatar" />
        <span class="header__user-name">
          <span class="header__welcome-line">Welcome,</span>
          <span class="header__welcome-name">{{ fullName() }}</span>
        </span>
      </div>
    }
  </div>
</header>
